import { useQuery } from "@tanstack/react-query"
import { getMasReport } from "./MasReportRepo"

export const useMasReport=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['Mas_REPORT',param],
        queryFn:()=>getMasReport(param),
        enabled:enable,
        retry:false,
    })
}
